import React, { Component } from "react";
import "./ButtonAlt.css";

class ButtonAlt extends Component {
	// Alternate console button
	render() {
		return (
			<button className={this.props.selected ? "fm-alt-button fm-alt-selected" : "fm-alt-button"} onClick={this.props.onClick}>
				{this.props.label}
			</button>
		);
	}
}

export default ButtonAlt;


// WEBPACK FOOTER //
// ./src/components/ButtonAlt/ButtonAlt.js